import { useTranslation } from "react-i18next"
import { getLocaleConfig } from "@/config/locale-domains"

export function useBrand() {
  const { i18n } = useTranslation()
  const code = i18n.language?.startsWith("hu") ? "hu" : "ro"
  return getLocaleConfig(code)
}
